<div class="image-box">
    <mat-form-field class="image-box__url" appearance="outline">
        <mat-label>{{normalizedLabel}}</mat-label>
        <span *ngIf="prefix" matTextPrefix>{{prefix}}</span>
        <input matInput type="text" name="{{label}}-{{key}}" #image="ngModel"
            [required]="required" [disabled]="disabled" [readonly]="readonly"
            urlValidator
            [urlPrefix]="prefix"
            attr.data-testid="record-{{label}}-image"
            [(ngModel)]="value" (ngModelChange)="onFieldChange.emit($event)">
            <mat-error *ngIf="image.errors?.isInvalidURL">URL is invalid.</mat-error>
    </mat-form-field>
    <img *ngIf="!image.errors?.isInvalidURL" [src]="imageUrl" class="image-box__image">
</div>
